module.exports = __webpack_public_path__ + "img/badge-4.8887a592.svg";